export const profetionalsData = {
    image: "./assets/imgs/profetionals/fondo.png",
    title: "CONTRATA A LOS",
    mainTitle: "PROFESIONALES",
    description: [
        " En HISOL, nos enorgullecemos de ofrecer los mejores servicios de construcción y restauración de altura en México.",
        "Le brindamos una experiencia con mínima disrupción en su negocio, manteniéndolo bien informado y documentado sobre el estado de su proyecto."
    ],
    link: {
        text: "CONOCER MÁS",
        href: "/contacto"
    }
};


export const profetionalsDataEn = {
    image: "./assets/imgs/profetionals/fondo.png",
    title: "HIRE THE",
    mainTitle: "PROFESSIONALS",
    description: [
        "At HISOL, we take pride in offering the best high-rise renovation and restoration services in Mexico.",
        "We provide a client experience with minimal disruption to your business, keeping you well-informed and documented on the status of your project."
    ],
    link: {
        text: "LEARN MORE",
        href: "/contacto"
    }
};
